import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './AuthContext'

export function ProtectedRoute() {
  const { isAuthenticated, isAuthChecking } = useAuth()
  if (isAuthChecking) return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <Outlet />
}
